import { render, staticRenderFns } from "./TermosRoot.vue?vue&type=template&id=6b6bd6b0&"
import script from "./TermosRoot.vue?vue&type=script&lang=js&"
export * from "./TermosRoot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports